import { useEffect, useLayoutEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FiShield, FiX } from "react-icons/fi";
import AdminSidebarSection from "./AdminSidebarSection";
import { ADMIN_PANEL_HOME, adminSidebarSections } from "./adminNavigation";
import "./AdminSidebar.css";

const SCROLL_STORAGE_KEY = "allhomedesire:admin-shell:sidebar-scroll-top";

const AdminSidebar = ({
  collapsed = false,
  isMobile = false,
  drawerOpen = false,
  onCloseDrawer,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const navRef = useRef(null);

  useLayoutEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    const navElement = navRef.current;

    if (!navElement) {
      return undefined;
    }

    const storedScroll = window.sessionStorage.getItem(SCROLL_STORAGE_KEY);

    if (storedScroll !== null) {
      navElement.scrollTop = Number(storedScroll);
    }

    return undefined;
  }, [drawerOpen, isMobile]);

  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    const navElement = navRef.current;

    if (!navElement) {
      return undefined;
    }

    const handleScroll = () => {
      window.sessionStorage.setItem(
        SCROLL_STORAGE_KEY,
        String(navElement.scrollTop)
      );
    };

    navElement.addEventListener("scroll", handleScroll, { passive: true });

    return () => navElement.removeEventListener("scroll", handleScroll);
  }, [drawerOpen, isMobile]);

  useEffect(() => {
    if (isMobile) {
      onCloseDrawer?.();
    }
  }, [isMobile, location.pathname, onCloseDrawer]);

  const handleNavigate = () => {
    if (isMobile) {
      onCloseDrawer?.();
    }
  };

  const renderPanel = (drawer = false) => (
    <div
      className={`admin-sidebar__panel${
        drawer ? " admin-sidebar__panel--drawer" : ""
      }`}
    >
      <div className="admin-sidebar__header">
        <button
          type="button"
          className="admin-sidebar__brand"
          onClick={() => navigate(ADMIN_PANEL_HOME)}
          title="Go to dashboard"
        >
          <span className="admin-sidebar__brand-mark">
            <FiShield size={18} />
          </span>
          <span className="admin-sidebar__brand-copy">AllHome Desire</span>
        </button>

        {drawer && (
          <button
            type="button"
            className="admin-sidebar__drawer-close"
            onClick={onCloseDrawer}
            aria-label="Close navigation"
          >
            <FiX size={18} />
          </button>
        )}
      </div>

      <div className="admin-sidebar__nav" ref={navRef}>
        {adminSidebarSections.map((section) => (
          <AdminSidebarSection
            key={section.id}
            title={section.title}
            items={section.items}
            collapsed={!drawer && collapsed}
            onNavigate={handleNavigate}
          />
        ))}
      </div>
    </div>
  );

  return (
    <div
      className={`admin-sidebar-root${
        collapsed && !isMobile ? " is-collapsed" : ""
      }`}
    >
      {!isMobile && <aside className="admin-sidebar__desktop-shell">{renderPanel()}</aside>}

      {isMobile && drawerOpen && (
        <>
          <button
            type="button"
            className="admin-sidebar__backdrop"
            onClick={onCloseDrawer}
            aria-label="Close navigation overlay"
          />
          <aside className="admin-sidebar__drawer is-open">{renderPanel(true)}</aside>
        </>
      )}
    </div>
  );
};

export default AdminSidebar;
